// extracted by mini-css-extract-plugin
module.exports = {"radius":"CategoryCard_radius__ZS8e8","imageTrans":"CategoryCard_imageTrans__iihgZ"};